module.exports = __webpack_public_path__ + "static/img/jiang2.0605dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang2.jpg
// module id = n745
// module chunks = 1